import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const printConsume = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_PRINT_CONSUME_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_PRINT_CONSUME_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_PRINT_CONSUME_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
